import React from 'react';
import { TCITooltip } from '@/components/ui/Tooltip';
import Icon from '@/components/ui/Icon';
import cn from '@/utils/cn';
import styles from './index.module.scss';

interface GradeShortcutProps {
  comingSoon?: boolean;
  disabled?: boolean;
  gradesLink: string;
}

interface ComingSoonButtonProps {
  label: string;
}

const ComingSoonButton = React.forwardRef<HTMLButtonElement, ComingSoonButtonProps>(
  ({ label, ...props }, ref) => (
    <button
      ref={ref}
      aria-disabled
      className={styles.icon}
      type="button"
      {...props}
    >
      <i aria-hidden="true" className={`fa fa-bar-chart ${styles.disabled}`} />
      <span className="sr-only">{label}</span>
    </button>
  ),
);
ComingSoonButton.displayName = 'ComingSoonButton';

interface GradesLinkProps {
  disabled?: boolean;
  gradesLink: string;
  label: string;
}

const GradesLink = React.forwardRef<HTMLAnchorElement, GradesLinkProps>(
  ({ disabled, gradesLink, label, ...props }, ref) => (
    <a
      ref={ref}
      aria-disabled={disabled || undefined}
      className={cn(styles.icon, styles.gradesLink, { [styles.disabled]: disabled })}
      href={disabled ? undefined : gradesLink}
      {...props}
    >
      <Icon className={cn({ [styles.disabled]: disabled })} icon="Grades" />
      <span className="sr-only">{label}</span>
    </a>
  ),
);
GradesLink.displayName = 'GradesLink';

const GradeShortcut = ({ comingSoon, disabled, gradesLink }: GradeShortcutProps) => {
  const tooltipContent = comingSoon ? 'Grading coming soon' : 'Grades';

  return (
    <TCITooltip side="bottom">
      <TCITooltip.Trigger asChild>
        {comingSoon
          ? <ComingSoonButton label={tooltipContent} />
          : <GradesLink disabled={disabled} gradesLink={gradesLink} label={tooltipContent} />}
      </TCITooltip.Trigger>
      <TCITooltip.Content>
        {tooltipContent}
      </TCITooltip.Content>
    </TCITooltip>
  );
};

GradeShortcut.defaultProps = {
  comingSoon: false,
  disabled: false,
};

export default GradeShortcut;
